const getParamsFromURL = (urlToSearch, params = []) => {
  try {
    const urlObj = new URL(urlToSearch);
    return params.map((param) => urlObj.searchParams.get(param));
  } catch (error) {
    return [];
  }
};

export default getParamsFromURL;
